import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames';
import { useApolloClient } from '@apollo/client';
import { Stack } from '@hub/stack';
import { withIsAboveFoldProvider } from '@scentregroup/shared/hub-components/is-above-fold-provider';
import { useResolvedTemplate } from '../../../../apps/website/lib/page-templates/advertising';
import { Module } from '../../../../apps/website/components/page-templates/modules';
import { get } from 'lodash';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ABOVE_FOLD_THRESHOLD = 2; // Is there a better way to do this?

const Div = props => /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
  "data-id": "page-templates_template_Div_div"
}));

export function getTemplateModules(template) {
  let activateH1Title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  let firstChildProcessed = false;
  return template.modules.flatMap((module, idx) => {
    let enableH1Heading = false;
    const args = ['sc-slot', "sc-slot-".concat(idx)];

    if (Object.keys(module).includes('analyticsMetadata')) {
      args.push("ad-content-".concat(module.analyticsMetadata.displayId.split('/')[3]));
    }

    if (activateH1Title && !firstChildProcessed && get(module, 'title') && (get(module, 'items') || []).length > 0) {
      firstChildProcessed = enableH1Heading = true;
    }

    const DivWithFold = withIsAboveFoldProvider(Div, idx < ABOVE_FOLD_THRESHOLD ? 'above' : 'below');
    return /*#__PURE__*/_jsx(DivWithFold, {
      className: classNames(...args),
      "data-id": "page-templates_template_Div_DivWithFold",
      children: /*#__PURE__*/_jsx(Module, {
        module: module,
        enableH1Heading: enableH1Heading,
        "data-id": "page-templates_template_Div_DivWithFold_Module"
      })
    }, idx);
  });
}
export function Template(_ref) {
  let {
    template: templateWithAdZones,
    id,
    activateH1Title,
    children
  } = _ref;
  const apollo = useApolloClient();
  const template = useResolvedTemplate(apollo, templateWithAdZones);
  const modules = React.useMemo(() => {
    return getTemplateModules(template, activateH1Title);
  }, [template, activateH1Title]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: modules.length ? /*#__PURE__*/_jsxs(Stack, {
      gap: ['spacing-3xl', null, 'spacing-4xl'],
      id: id,
      "data-id": "page-templates_template_Div_Stack",
      children: [children, modules]
    }) : null
  });
}